import { memo, useCallback, useState } from 'react';
import cn from 'classnames';
import { ArrayUtils } from 'src/utils';
import { pushLogAdNative } from 'src/redux/actions/ad';
import {
    Button,
    Element,
    Icon,
    Image,
    Checkbox,
    RouterLink,
    Title,
} from 'src/components';
import Menu from 'src/components/menu';
import Card from 'src/components/card';

export type CONTENT_REPORT = {
    DEFAULT: 'default';
    HIDE: 'hide';
    DESKTOP: 'desktop';
    TOUCH: 'touch';
    TABLET: 'tablet';
    MOBILE: 'mobile';
};

export interface IReasion {
    id: number;
    text: string;
}

const CHECKBOX_HIDE = [
    {
        id: 12,
        text: 'Nhạy cảm',
    },
    {
        id: 13,
        text: 'Lỗi hiển thị',
    },
    {
        id: 14,
        text: 'Hiện nhiều lần',
    },
    {
        id: 15,
        text: 'Không phù hợp',
    },
    {
        id: 16,
        text: 'Đã mua rồi',
    },
];

const CHECKBOX_REPORT = [
    {
        id: 2,
        text: 'Phản cảm/Bạo lực',
    },
    {
        id: 3,
        text: 'Giả mạo, lừa đảo',
    },
    {
        id: 4,
        text: 'Gây hiểu lầm',
    },
    {
        id: 5,
        text: 'Có nội dung cấm',
    },
    {
        id: 6,
        text: 'Dẫn về trang tin giả',
    },
    {
        id: 7,
        text: 'Spam',
    },
];

const ITEM_OTHER = {
    id: 1,
    text: 'Khác',
};

export default memo(function ModalReport({ hide, onSubmit, item }: any) {
    const [showCheckbox, setShowCheckbox] = useState<boolean>(false);
    const listHideReason = [
        ...ArrayUtils.shuffle(CHECKBOX_HIDE),
        ITEM_OTHER,
    ] as IReasion[];
    const listReportReason = [
        ...ArrayUtils.shuffle(CHECKBOX_REPORT),
        ITEM_OTHER,
    ] as IReasion[];
    const [value, setValue] = useState<number>(0);
    const [fbLanding, setFbLanding] = useState<number>(0);
    const [listReasion, setListReasion] = useState<IReasion[]>([]);
    const { sourceId } = item;

    const handleHideAds = useCallback(
        (listHideReason: any, fbLanding: any) => {
            setShowCheckbox(true);
            setListReasion(listHideReason);
            setFbLanding(fbLanding);
        },
        [showCheckbox, listHideReason]
    );

    const onChange = useCallback((e: any) => {
        setValue(+e.target.name);
    }, []);

    const renderCheckbox = useCallback(() => {
        return (
            <Menu.List className="flex flex-wrap">
                {listReasion.map((item) => {
                    const checked = item.id === value;
                    return (
                        <Menu.List.Item
                            className="shrink-0 mt-[10px] mr-[10px]"
                            key={item.id}
                        >
                            <Checkbox
                                classNameCheckbox={'peer/checkbox hidden'}
                                classNameLabel={cn(
                                    'flex items-center justify-center',
                                    'relative',
                                    'text-[1.6rem]',
                                    'px-[11px] py-[5px]',
                                    'rounded-[10px]',
                                    'bg-white',
                                    'transition-all',
                                    'peer-checked/checkbox:bg-[var(--primary)] peer-checked/checkbox:text-white'
                                )}
                                checked={checked}
                                name={`${item.id}`}
                                onChange={onChange}
                            >
                                {item.text}
                            </Checkbox>
                        </Menu.List.Item>
                    );
                })}
            </Menu.List>
        );
    }, [value, listReasion]);

    const submitReport = useCallback(() => {
        const arrSource = sourceId.split(',');
        const zoneId = arrSource[0];
        const bannerId = arrSource[1];
        const deviceId = arrSource[2];
        const params = {
            bannerId,
            deviceId,
            zoneId,
            useragent: navigator.userAgent,
            fbLanding,
            fbType: value,
        };
        pushLogAdNative(params);
        onSubmit(fbLanding);
        hide();
    }, [sourceId, fbLanding, value]);

    return (
        <Card>
            <Card.Header
                className={cn(
                    'flex items-center',
                    'px-[14px] py-[10px]',
                    'border-b border-solid border-[#ddd]'
                )}
            >
                <Title className="text-[1.8rem]">Thông tin quảng cáo</Title>
                <Element renderAs="a" onClick={hide}>
                    <Icon
                        className={cn(
                            'absolute top-[15px] right-[15px]',
                            'text-[1.5rem] text-black',
                            'opacity-50'
                        )}
                        icon="close"
                    />
                </Element>
            </Card.Header>
            <Card.Content className="flex p-[14px]">
                <Image
                    className={cn(
                        'w-[50px] h-[50px]',
                        'shrink-0',
                        'rounded-[5px]',
                        'overflow-hidden',
                        'bg-[#eee]',
                        '[&_img]:object-cover'
                    )}
                    title={`Quảng cáo ${item.title}`}
                    src={item.thumb[0]}
                />
                <Element
                    className={cn(
                        'text-[1.8rem] text-[#242424] leading-[1.2]',
                        'pl-[15px]',
                        'line-clamp-3',
                        'select-none'
                    )}
                >
                    {item.title}
                </Element>
            </Card.Content>
            <>
                {showCheckbox ? (
                    <>
                        <Card.Footer
                            className={cn(
                                'flex-col',
                                'text-[var(--dark)] text-center',
                                'p-[14px]',
                                'h-auto',
                                'rounded-none',
                                'bg-[#ededed]',
                                '[&>:not(:first-child)]:ml-0'
                            )}
                        >
                            <Element className={'text-[1.4rem] text-[#666]'}>
                                Vui lòng chia sẻ lý do bạn muốn ẩn quảng cáo này
                            </Element>
                            {renderCheckbox()}
                            <Element
                                className={cn(
                                    'text-[#717171] text-[1.4rem] leading-[17px] text-left',
                                    'mt-[20px]',
                                    'rounded-[10px]',
                                    'border border-solid border-[#c5c5c5]',
                                    'py-[6px] pr-[16px] pl-[22px]'
                                )}
                            >
                                Tìm hiểu thêm về
                                <RouterLink
                                    className="text-[#262626] font-semibold"
                                    newTab
                                    to="https://ads.zalo.me/business/p/chinh-sach/"
                                >
                                    &nbsp;chính sách quảng cáo&nbsp;
                                </RouterLink>
                                của chúng tôi
                            </Element>
                        </Card.Footer>
                        <Element className={'text-center bg-white px-[32px]'}>
                            <Button
                                className={cn(
                                    'flex text-center justify-center',
                                    'text-[1.6rem] text-white',
                                    'w-full',
                                    'my-[10px] px-0 py-[8px]',
                                    'rounded-[10px]',
                                    'bg-[#2fa1b3]',
                                    'transition-all duration-[0.35s] ease-[ease]',
                                    'disabled:bg-[#f0f0f0] disabled:text-[#999]'
                                )}
                                title="Xác nhận"
                                disabled={value === 0}
                                onClick={submitReport}
                            >
                                Xác nhận
                            </Button>
                        </Element>
                    </>
                ) : (
                    <>
                        <Card.Footer
                            className={cn(
                                'flex-col',
                                'text-[var(--dark)] text-center',
                                'p-[14px]',
                                'h-auto',
                                'rounded-none',
                                'bg-[#ededed]',
                                '[&>:not(:first-child)]:ml-0'
                            )}
                        >
                            <Element className={'text-[1.4rem] text-[#666]'}>
                                Các thao tác mà bạn có thể thực hiện
                            </Element>
                            <Button
                                title="Ẩn"
                                className={cn(
                                    'flex items-center justify-center',
                                    'text-[1.6rem]',
                                    'mt-[10px] py-[8px]',
                                    'rounded-[8px]',
                                    'w-[90%]',
                                    'bg-white',
                                    'border border-solid border-[#ccc]'
                                )}
                                onClick={() => handleHideAds(listHideReason, 2)}
                            >
                                Ẩn quảng cáo này
                            </Button>
                            <Button
                                className={cn(
                                    'flex items-center justify-center',
                                    'text-[1.6rem]',
                                    'mt-[10px] py-[8px]',
                                    'rounded-[8px]',
                                    'w-[90%]',
                                    'bg-white',
                                    'border border-solid border-[#ccc]'
                                )}
                                title="Báo xấu"
                                onClick={() =>
                                    handleHideAds(listReportReason, 3)
                                }
                            >
                                Báo xấu quảng cáo
                            </Button>
                        </Card.Footer>

                        <Element className={'text-center bg-white px-[32px]'}>
                            <Element
                                className={'text-[1.2rem] text-[#ccc] p-[6px]'}
                            >
                                Quảng cáo từ adtima
                            </Element>
                        </Element>
                    </>
                )}
            </>
        </Card>
    );
});
